import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { History } from 'lucide-react';
import { formatDate } from '../../lib/utils';

/**
 * Audit-log table for an employee. Stateless / pure presentation.
 */
export function EmployeeAuditLog({ auditLog }) {
  return (
    <div className="glass-card p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <History className="w-5 h-5 text-primary" />
        Audit Log
      </h3>
      {auditLog.length > 0 ? (
        <div className="table-scroll">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Action</TableHead>
              <TableHead>Changes</TableHead>
              <TableHead>Timestamp</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {auditLog.map((log) => (
              <TableRow key={log.id}>
                <TableCell>
                  <Badge variant="outline" className="capitalize">{log.action}</Badge>
                </TableCell>
                <TableCell className="max-w-md">
                  <code className="text-xs bg-secondary/50 p-1 rounded">
                    {JSON.stringify(log.changes).slice(0, 100)}...
                  </code>
                </TableCell>
                <TableCell>{formatDate(log.timestamp)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          No audit history
        </div>
      )}
    </div>
  );
}
